import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useClinicsList = () => {
  const [data, setData] = useState();
  const getList = async (params) => {
    // Fetch clinics list
    const list = await apiService.getAllClinics(params);
    list && setData(list); // update data state
    return list;
  };

  return {
    data,
    getList,
  };
};
